
import VideoPlayer from '~/components/VideoPlayer/videojs.vue'
import Modal from '@/components/Shared/Modal/index.vue'
import { mapGetters } from 'vuex'
function convertM2H(n) {
  const num = n
  const day = num / 3600
  const rday = Math.floor(day)
  const hours = (day - rday) * 60
  const rhours = Math.floor(hours)
  const minutes = (hours - rhours) * 60
  const rminutes = Math.round(minutes)
  return (
    (rday >= 1 ? (rday < 10 ? `0${rday}` : rday) + ':' : '') +
    (rhours < 10 ? `0${rhours}` : rhours) +
    ':' +
    (rminutes < 10 ? `0${rminutes}` : rminutes)
  )
}
export default {
  data() {
    return {
      loginForPreviewModal: false,
      actives: [],
      videoOptions: {
        live: true,
        autoplay: true,
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        sources: [
          {
            src: '',
            type: 'application/x-mpegURL',
          },
        ],
      },
      videoPreview: {
        status: false,
        url: '',
        title: '',
      },
      videoLink: {
        token: '',
        link: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  methods: {
    convertM2H,
    SET_ACTIVE(i) {
      this.actives = this.actives.includes(i)
        ? this.actives.filter((a) => a !== i)
        : [...this.actives, i]
    },
    CHECK_LOGIN_PREVIEW() {
      this.loginForPreviewModal = true
    },
    PERCENT(videos) {
      const videosLength = videos.length
      const isFinishedLength = videos.filter((v) => v.isFinished === 1).length
      return Math.floor((isFinishedLength * 100) / videosLength) + 1
    },
    VIDEO_PERCENT(video) {
      return Math.round((video.watchedDuration * 100) / video.duration) + 1
    },
    async SET_VIDEO(video) {
      const splitVideoLength = video.videoPath.split('/')
      if (splitVideoLength.length > 1) {
        const response = await this.$api.get('Videos/GetCDNStream/' + video.id)
        if (response.message === 'OK') {
          this.videoLink = response.data
          this.videoOptions.sources[0].src = response.data.link
        }
      } else {
        this.videoOptions.sources[0].src = `${
          this.$api.BASE_URL
        }/Videos/GetStream/${video.id}/${'360'}/part.m3u8`
      }
      this.videoPreview = {
        status: true,
        title: video.description,
      }
    },
    async SET_ROUTE(id, action, event) {
      if (
        action ||
        !this.getActiveUser.token ||
        event.target.classList.contains('preview-span')
      )
        return
      const response = await this.$api.put(
        `UserCourses/CheckPrev?videoId=${id}`,
        {}
      )
      if (response.message === 'OK') {
        this.$router.push(
          this.localePath(`/urun/${this.product.id}/video/${id}`)
        )
      }
    },
  },
  components: { VideoPlayer, Modal },
  mounted() {
    if (this.product.sections.length === 1) {
      this.actives = [0]
    }
  },
}
